module.exports = __webpack_public_path__ + "static/built-in-easy-ab-testing-982de7f8b8526bb262d7128a6cd7b116.mp4";